<div *ngIf="dataLoaded">
    <aumico-table [options]="options" [data]="data" [delegate]="this" [filterSubject]="onFilterEvent"> </aumico-table>
</div>
